import { computed, observable, decorate, action } from 'mobx'
import { CURRENCY_FORMAT_CHAR } from 'basic/config'

export class CurrencyStore {
  list = []
  current = null

  defaultCurrency = {
    code: '',
    title: '',
    scale: 0,
    format: CURRENCY_FORMAT_CHAR,
  }

  constructor(rootStore) {
    this.rootStore = rootStore
  }

  init(result) {
    this.current = result.current.id
    this.list = result.list
  }

  getCurrency(id) {
    const currency = this.list.find(currency => `${currency.id}` === `${id}`)
    return currency != null ? currency : this.defaultCurrency
  }

  get currentData() {
    return this.getCurrency(this.current)
  }
}

decorate(CurrencyStore, {
  init: action,
  list: observable,
  current: observable,
  currentData: computed,
})
